var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"notifications":_vm.notifications,"deleteNotification":_vm.deleteNotification,"deleteAllNotification":_vm.deleteAllNotification})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }